<!-- section template -->
<template>
  <ul v-loading="loading" :element-loading-text="loadingText" :class="$style.baseOrderList">
    <li v-for="(orderItem, index) in orderList" :key="index" class="baseOrderList__item">
      <div v-if="orderItem.head && !!orderItem.head[0]" class="baseOrderList__head">
        <div class="baseOrderList__no"> 訂單編號：#{{ orderItem.displayId }} </div>
        <ul :class="$style.headList">
          <li v-for="(headItem, index2) in orderItem.head" :key="`headList-${index2}`" class="headList__item" :class="headItem.class">
            <span v-if="!!headItem.title" class="headList__title" :class="headItem.titleClass" v-html="headItem.title"></span>
            <span v-if="!!headItem.text" class="headList__text" :class="headItem.textClass" v-html="headItem.text"></span>
          </li>
        </ul>
      </div>

      <div v-if="orderItem.body && !!orderItem.body[0]" class="baseOrderList__addOrder">
        <BaseOrderListOrderToggle :order-list="orderItem.body" />
      </div>

      <div v-if="orderItem.foot && !!orderItem.foot[0]" class="baseOrderList__foot mt-3">
        <ul :class="$style.footList">
          <li v-for="(footItem, index2) in orderItem.foot" :key="`footList-${index2}`" class="footList__item" :class="footItem.class">
            <template v-if="!footItem.type || footItem.type === 'button'">
              <BaseButton :class="footItem.buttonClass" @click="footItem.onClick()">
                <span v-html="footItem.text"></span>
              </BaseButton>
            </template>
            <template v-if="footItem.type === 'dropdown'">
              <el-dropdown :hide-on-click="false" placement="bottom-start" class="w-100">
                <BaseButton :class="footItem.buttonClass" @click.stop.prevent>
                  <span v-html="footItem.text"></span>
                </BaseButton>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(dropdownItem, index3) in footItem.dropdown" :key="`dropdownItem-${index3}`" :class="dropdownItem.class" @click.native="dropdownItem.onClick()">
                    <span v-html="dropdownItem.text"></span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import BaseStoreTagList from './BaseStoreTagList'
export default {
  components: { BaseStoreTagList },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: '',
    },
    orderList: {
      type: Array,
      default: () => {
        return [
          {
            head: [
              {
                title: '',
                titleClass: '',
                text: '迷你犬包套皮毛管理',
                textClass: '',
                class: '',
              },
              {
                title: '使用期限',
                titleClass: '',
                text: '2021/08/25',
                textClass: '',
                class: '',
              },
              {
                title: '剩餘抵用次數',
                titleClass: '',
                text: '剩餘抵用次數：99+/99+',
                textClass: '',
                class: '',
              },
            ],
            body: [],
            foot: [
              {
                type: 'button',
                text: '預約',
                class: 'flex-grow-1',
                buttonClass: 'isStylePrimary isOutline3 isRadius isSmall isFull',
                onClick: () => {},
              },
              {
                type: 'dropdown',
                text: '更多',
                class: 'flex-grow-1',
                buttonClass: 'isStylePrimary isOutline3 isRadius isSmall isFull',
                dropdown: [
                  {
                    text: '前往付款',
                    class: '',
                    onClick: () => {},
                  },
                  {
                    text: '查看訂單',
                    class: '',
                    onClick: () => {},
                  },
                  {
                    text: '再次購買',
                    class: '',
                    onClick: () => {},
                  },
                  {
                    text: '聯繫我們',
                    class: '',
                    onClick: () => {},
                  },
                ],
              },
            ],
          },
        ]
      },
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.baseOrderList {
  @include list-unstyled;

  :global {
    .baseOrderList {
      &__item {
        padding-bottom: 1.5rem;
        margin-bottom: 1.8rem;
        padding: 1.2rem 1.5rem 1.5rem;
        // border-bottom: $color-line 1px solid;
        background: #f9f9fc;
      }
      &__no {
        padding: 0.75rem;
        background: #fff;
        border: 1px solid $color-primary;
        margin-bottom: 1rem;
      }
      &__head {
        line-height: 1.75;
        // color: $color-primary-dark;
        // background-color: rgba($color-primary, 0.1);
      }

      &__body {
        padding: 1rem 1.5rem;
        margin-bottom: 0;
        font-size: 0.875rem;
        line-height: 1.75;
      }

      &__addOrder {
        @include unstyled;
      }

      &__foot {
        @include unstyled;
      }
    }
  }
}

.headList {
  @include list-unstyled;
  @include max-md {
    margin: 1rem 0;
  }

  :global {
    .headList {
      &__item {
        @include unstyled;
      }

      &__title {
        &::after {
          content: ':';
        }
      }

      &__text {
        @include unstyled;
      }
    }
  }
}

.bodyList {
  @include list-unstyled;
  position: relative;

  :global {
    .bodyList {
      &__item {
        @include unstyled;
      }

      &__title {
        &::after {
          content: '：';
        }
      }

      &__text {
        @include unstyled;
      }
    }
  }
}

.footList {
  @include list-unstyled;
  display: flex;
  align-items: center;

  :global {
    .footList {
      &__item {
        &:not(:last-child) {
          margin-right: 0.5rem;
        }
      }

      &__title {
        @include unstyled;
      }

      &__text {
        @include unstyled;
      }
    }
  }
}
</style>
